import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Mail, Lock, Phone, User, MapPin } from 'lucide-react';
export function SignUpScreen() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isSignIn, setIsSignIn] = useState(location.state?.mode === 'signin');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    navigate('/otp');
  };
  return <div className="min-h-screen bg-ui-bg flex flex-col" data-id="element-1629">
      <div className="pt-12 px-6 pb-6" data-id="element-1630">
        <h1 className="text-3xl font-bold text-text-main mb-2" data-id="element-1631">
          {isSignIn ? 'Welcome back' : 'Create account'}
        </h1>
        <p className="text-text-secondary" data-id="element-1632">
          {isSignIn ? 'Sign in to continue your care journey.' : 'Join Whiz to find trusted care near you.'}
        </p>
      </div>

      <div className="flex px-6 mb-6" data-id="element-1633">
        <div className="flex bg-ui-card p-1 rounded-xl w-full" data-id="element-1634">
          <button onClick={() => setIsSignIn(false)} className={`flex-1 py-2.5 text-sm font-medium rounded-lg transition-colors ${!isSignIn ? 'bg-white shadow-sm text-text-main' : 'text-text-secondary'}`} data-id="element-1635">
            Sign Up
          </button>
          <button onClick={() => setIsSignIn(true)} className={`flex-1 py-2.5 text-sm font-medium rounded-lg transition-colors ${isSignIn ? 'bg-white shadow-sm text-text-main' : 'text-text-secondary'}`} data-id="element-1636">
            Sign In
          </button>
        </div>
      </div>

      <div className="flex-1 px-6 pb-8 overflow-y-auto" data-id="element-1637">
        <form onSubmit={handleSubmit} className="space-y-4" data-id="element-1638">
          {!isSignIn && <div className="space-y-1" data-id="element-1639">
              <label className="text-sm font-medium text-text-main" data-id="element-1640">
                Full Name
              </label>
              <div className="relative" data-id="element-1641">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1642">
                  <User size={18} className="text-text-secondary" data-id="element-1643" />
                </div>
                <input type="text" placeholder="e.g. Oluwaseun Adebayo" className="w-full pl-10 pr-4 py-3 bg-ui-card border border-ui-border rounded-xl focus:ring-2 focus:ring-brand-primary focus:border-transparent outline-none transition-all" required data-id="element-1644" />
              </div>
            </div>}

          <div className="space-y-1" data-id="element-1645">
            <label className="text-sm font-medium text-text-main" data-id="element-1646">
              Phone Number
            </label>
            <div className="relative flex" data-id="element-1647">
              <div className="flex items-center justify-center px-3 bg-ui-card border border-ui-border border-r-0 rounded-l-xl text-text-main font-medium" data-id="element-1648">
                +234
              </div>
              <input type="tel" placeholder="801 234 5678" className="w-full pl-3 pr-4 py-3 bg-ui-card border border-ui-border rounded-r-xl focus:ring-2 focus:ring-brand-primary focus:border-transparent outline-none transition-all" required data-id="element-1649" />
            </div>
          </div>

          {!isSignIn && <div className="space-y-1" data-id="element-1650">
              <label className="text-sm font-medium text-text-main" data-id="element-1651">
                Email (Optional)
              </label>
              <div className="relative" data-id="element-1652">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1653">
                  <Mail size={18} className="text-text-secondary" data-id="element-1654" />
                </div>
                <input type="email" placeholder="your@email.com" className="w-full pl-10 pr-4 py-3 bg-ui-card border border-ui-border rounded-xl focus:ring-2 focus:ring-brand-primary focus:border-transparent outline-none transition-all" data-id="element-1655" />
              </div>
            </div>}

          <div className="space-y-1" data-id="element-1656">
            <label className="text-sm font-medium text-text-main" data-id="element-1657">
              Password
            </label>
            <div className="relative" data-id="element-1658">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1659">
                <Lock size={18} className="text-text-secondary" data-id="element-1660" />
              </div>
              <input type="password" placeholder="••••••••" className="w-full pl-10 pr-4 py-3 bg-ui-card border border-ui-border rounded-xl focus:ring-2 focus:ring-brand-primary focus:border-transparent outline-none transition-all" required data-id="element-1661" />
            </div>
          </div>

          {!isSignIn && <div className="pt-2" data-id="element-1662">
              <label className="flex items-start space-x-3" data-id="element-1663">
                <input type="checkbox" className="mt-1 w-4 h-4 text-brand-primary rounded border-ui-border focus:ring-brand-primary" required data-id="element-1664" />
                <span className="text-sm text-text-secondary" data-id="element-1665">
                  I agree to Whiz's Terms of Service and Privacy Policy, and
                  allow access to my location for nearby services.
                </span>
              </label>
            </div>}

          <div className="pt-4" data-id="element-1666">
            <button type="submit" className="w-full bg-brand-primary text-white font-semibold text-lg py-4 rounded-xl shadow-md active:scale-[0.98] transition-transform" data-id="element-1667">
              {isSignIn ? 'Sign In' : 'Create Account'}
            </button>
          </div>
        </form>

        <div className="mt-8" data-id="element-1668">
          <div className="relative" data-id="element-1669">
            <div className="absolute inset-0 flex items-center" data-id="element-1670">
              <div className="w-full border-t border-ui-border" data-id="element-1671"></div>
            </div>
            <div className="relative flex justify-center text-sm" data-id="element-1672">
              <span className="px-2 bg-ui-bg text-text-secondary" data-id="element-1673">
                Or continue with
              </span>
            </div>
          </div>

          <div className="mt-6 grid grid-cols-2 gap-4" data-id="element-1674">
            <button className="flex items-center justify-center py-3 px-4 border border-ui-border rounded-xl bg-white active:bg-gray-50 transition-colors" data-id="element-1675">
              <svg className="w-5 h-5 mr-2" viewBox="0 0 24 24" data-id="element-1676">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" data-id="element-1677" />
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" data-id="element-1678" />
                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" data-id="element-1679" />
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" data-id="element-1680" />
              </svg>
              <span className="text-sm font-medium text-text-main" data-id="element-1681">Google</span>
            </button>
            <button className="flex items-center justify-center py-3 px-4 border border-ui-border rounded-xl bg-white active:bg-gray-50 transition-colors" data-id="element-1682">
              <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24" data-id="element-1683">
                <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.04 2.34-.85 3.73-.78 1.44.06 2.6.71 3.33 1.8-3.13 1.88-2.62 6.03.48 7.34-.73 1.8-1.66 3.45-2.62 3.81zm-2.82-14.2c.6-1.54-.4-3.28-1.89-3.88-.66 1.63.49 3.33 1.89 3.88z" data-id="element-1684" />
              </svg>
              <span className="text-sm font-medium text-text-main" data-id="element-1685">Apple</span>
            </button>
          </div>
        </div>
      </div>
    </div>;
}